import $ from 'jquery'

export function initialise() {
  setTimeout(() => {
    $('[data-sticky]').each((i, elem) => {
      const observer = new IntersectionObserver(
        ([e]) => {
          e.target.classList.toggle('is-pinned', e.intersectionRatio < 1)
        },
        { threshold: [1] }
      )
      observer.observe(elem)
    })
  }, 750)
}
